import 'react-app-polyfill/ie11';
import 'url-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/App';
import * as serviceWorker from './serviceWorker';
import './index.css';
import { loadLocales, determineBrowserLocale } from './utils/locale';

const initAndRender = async () => {
  const locale = determineBrowserLocale();

  // loadLocales handles fallback langagues
  await loadLocales(locale);
  ReactDOM.render(<App />, document.getElementById('root'));
};

initAndRender();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
